export const GET_APPROVALS_CHECK_REQUEST = 'GET_APPROVALS_CHECK_REQUEST';
export const GET_APPROVALS_CHECK_REQUEST_FAILURE = 'GET_APPROVALS_CHECK_REQUEST_FAILURE';
export const GET_APPROVALS_CHECK_REQUEST_SUCCESS = 'GET_APPROVALS_CHECK_REQUEST_SUCCESS';

export const DISMISS_BROWSER_WARNING = 'DISMISS_BROWSER_WARNING';
